/* globalmodule */
define( '../src/sublayouts/m38-step-tracker/m38-step-tracker',[ 'jquery' ], function ( $ ) {

	'use strict';

	var StepTracker = function ( $component ) {

		this.$component = $component;

		return this;
	};

	StepTracker.prototype.init = function () {
		var _this = this;

		this.totalSteps = parseInt( this.$component.attr( 'data-total-steps' ) );
		this.currentStep = parseInt(this.$component.attr( 'data-current-step' ));
		this.$progressbar = this.$component.find( '[data-m38-progressbar]' );

		this.build();
		this.applyAria();

		$(window).off('reinit_m38').on('reinit_m38', function() {
			_this.init();
		});

		if (this.$component.attr('data-hasInfo') == "true") {
			_this.buildInfo();
		};

	};

	StepTracker.prototype.buildInfo = function () {
		var _this = this,
			valuetext = _this.$progressbar.attr('aria-valuetext'),
			word = _this.$component.data('labels').conjunction,
			info = '<div class="m38-steptracker__info-wrapper">'+_this.currentStep+' '+word+' '+_this.totalSteps+': <span class="m38-steptracker__info-value">'+valuetext+'</span></div>';

		$('.m38-steptracker__info-wrapper').remove();
		_this.$component.prepend(info);

	};

	StepTracker.prototype.build = function () {

		$(this.$progressbar).html("");

		for ( var i = 0; i < this.totalSteps; i = i + 1 ) {

			var $step = $( '<div class="m38-steptracker__step"></div>' );

			if ( this.currentStep > i ) {
				$step.addClass( 'm38-steptracker__step--active' );
			}

			this.$progressbar.append( $step );

		}

	};

	StepTracker.prototype.applyAria = function () {

		this.$progressbar.attr( 'aria-valuenow', 100 / this.totalSteps ).attr( 'aria-valuemin', 0 ).attr( 'aria-valuemax', 100 );
	};

	return StepTracker;

} );

